import axios from '@/libs/api.request'

/**
 * 获取列表
 * @returns {wx.RequestTask | never}
 */
export const getList = (params) => {
  return axios.request({
    url: 'userManage/UserList/index',
    method: 'get',
    params: params
  })
}




/**
 * 删除数据
 */
export const del = (id) => {
  return axios.request({
    url: 'userManage/UserList/del',
    method: 'get',
    params: {
      id: id
    }
  })
}

/**
 * 改变状态按钮
 * @param status
 * @param id
 * @returns {wx.RequestTask | never}
 */
export const changeStatus = (status, id) => {
  return axios.request({
    url: 'userManage/UserList/changeStatus',
    method: 'get',
    params: {
      status: status,
      id: id
    }
  })
}

/**
 * 锁定/解锁
 */
export const lock = (id,is_lock) => {
  return axios.request({
    url: 'userManage/UserList/lock',
    method: 'get',
    params: {
      id: id,
      is_lock:is_lock
    }
  })
}


/**
 * 锁定/解锁
 */
export const changeLevel = (id,level) => {
  return axios.request({
    url: 'userManage/UserList/changeLevel',
    method: 'get',
    params: {
      id: id,
      level:level
    }
  })
}

/**
 * 锁定/解锁
 */
export const changeGrade = (id,grade) => {
  return axios.request({
    url: 'userManage/UserList/changeGrade',
    method: 'get',
    params: {
      id: id,
      grade:grade
    }
  })
}


/**
 * 锁定/解锁
 */
export const addKefu = (id,kefu) => {
  return axios.request({
    url: 'userManage/UserList/addKefu',
    method: 'get',
    params: {
      id: id,
      kefu:kefu
    }
  })
}

/**
 * 锁定/解锁
 */
export const changeVipExpireTime = (id,vip_expire_time) => {
  return axios.request({
    url: 'userManage/UserList/changeVipExpireTime',
    method: 'get',
    params: {
      id: id,
      vip_expire_time:vip_expire_time
    }
  })
}

/**
 *
 */
export const changeIsCanWithdraw = (id,is_can_withdraw) => {
  return axios.request({
    url: 'userManage/UserList/changeIsCanWithdraw',
    method: 'get',
    params: {
      id: id,
      is_can_withdraw:is_can_withdraw
    }
  })
}

/**
 * 锁定/解锁
 */
export const changeRemark = (id,remark) => {
  return axios.request({
    url: 'userManage/UserList/changeRemark',
    method: 'get',
    params: {
      id: id,
      remark:remark
    }
  })
}


/**
 * 新增
 * @param data
 * @returns {wx.RequestTask | never}
 */
export const add = (data) => {
  return axios.request({
    url: 'userManage/UserList/add',
    method: 'post',
    data
  })
}


export const resetPass = (isSafe, user_id,password) => {
  return axios.request({
    url: 'userManage/UserList/resetPass',
    method: 'get',
    params: {
      isSafe: isSafe,
      id: user_id,
      password: password,
    }
  })
}

/**
 * 编辑
 * @param data
 * @returns {wx.RequestTask | never}
 */
export const edit = (data) => {
  return axios.request({
    url: 'userManage/UserList/edit',
    method: 'post',
    data
  })
}
